module.exports = __webpack_public_path__ + "img/vuesax-login-bg.04351a33.jpg";